import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Globals } from '../globals';
import { map, catchError } from 'rxjs/operators';
import { ConfigurationsService } from 'src/app/Service/configurations.service';

@Injectable({
    providedIn: 'root'
})
export class AlertMasterService {
    private httpHeader = new HttpHeaders();

    constructor(private http: HttpClient, private _global: Globals, private configService: ConfigurationsService) {
        this.httpHeader.append('Access-Control-Allow-Origin', '*');
    }

    GetAlertList(reqparam: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'AlertMaster' + '/GetAlertList';
        return this.http.post(serviceCallURL, reqparam)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    DeleteAlert(AlertId: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'AlertMaster' + '/DeleteAlert?AlertId=' + AlertId;
        return this.http.get(serviceCallURL)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    AddAlert(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'AlertMaster' + '/AddAlert';
        return this.http.post(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    EditAlert(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'AlertMaster' + '/EditAlert';
        return this.http.post(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    GetAlertDetailsList(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'AlertMaster' + '/GetAlertDetailsList';
        return this.http.post(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }
}
